import React from 'react';
import PropTypes from 'prop-types';
import Iframe from '../shared/Iframe';

/**
 * Figma component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const Figma = props => (
  <Iframe
    title="Figma"
    src={props.params.ludus.url}
    transitionStatus={props.transitionStatus}
    style={{ ...props.style, opacity: props.groupOpacity }}
    params={props.params}
    applyScaleFix={props.applyScaleFix}
    globalScale={props.globalScale}
    windowHasFocus={props.windowHasFocus}
    groupAngle={props.groupAngle}
    groupScaleX={props.groupScaleX}
    groupScaleY={props.groupScaleY}
    matrixGroup={props.matrixGroup}
    isScalable={false}
  />
);
Figma.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  applyScaleFix: PropTypes.bool.isRequired,
  globalScale: PropTypes.number.isRequired,
  windowHasFocus: PropTypes.bool.isRequired,
  groupAngle: PropTypes.number.isRequired,
  groupOpacity: PropTypes.number.isRequired,
  groupScaleX: PropTypes.number.isRequired,
  groupScaleY: PropTypes.number.isRequired,
  transitionStatus: PropTypes.string.isRequired,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
};
Figma.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
};

export default Figma;
